import React from 'react'
import ReactDOM from 'react-dom'
import './StatusMenu.css';
import PropTypes from 'prop-types'
import statusCurrentIssue from '../../assets/images/status-current-issue.svg';
import statusFutureIssue from '../../assets/images/status-future-issue.svg';
// import PopupBox from '../proksee-viewer/presenters/PopupBox';
// import DataElement from '../proksee-viewer/presenters/DataElement';
// import DataElementGroup from '../proksee-viewer/presenters/DataElementGroup';
// import TextElement from '../proksee-viewer/presenters/TextElement';
import consumer from '../channels/consumer';
import * as helpers from "../proksee-viewer/support/Helpers";

class StatusMenu extends React.Component {

  static propTypes = {
    role:    PropTypes.string,
    status:  PropTypes.string,
  }

  static defaultProps = {
    role: '',
    status: '',
  }

  constructor(props) {
    super(props);
    this.state = {
      current: false,
      future: false,
    };
    this.refreshState = this.refreshState.bind(this);
  }

  componentDidMount() {
    const refreshState = this.refreshState;
    consumer.subscriptions.create({channel: "StatusChannel"}, {
      connected() {
        // Called when the subscription is ready for use on the server
        console.log('Status Connected')
      },

      disconnected() {
        // Called when the subscription has been terminated by the server
      },

      received(site_notices) {
        // Called when there's incoming data on the websocket for this channel
        console.log('Status Data Received:')
        console.log(site_notices)
        refreshState(site_notices);
        // site_notices: { current: [notice1], future: [notice2, notice3] }
        // Where each notice is an object with the following properties:
        //   - title: title of the notice
        //   - message: body of the notice
        //   - started_at: start date/time of the notice
        //   - ended_at: end date/time of the notice
        //   - category: category of the notice (maintenance, outage, etc.)
      }
    });
  }

  refreshState(site_notices) {
    this.setState({
      current: site_notices.current.length > 0,
      future:  site_notices.future.length > 0,
    });
  }

  render() {
    const { current, future } = this.state;
    console.log('StatusMenu State:')
    console.log(this.state)
    return (
      <div className='StatusMenu'>
        {current && (
          <a href="/status" title="Service Outage. See Status Page">
            <img src={statusCurrentIssue} alt="Service Outage" />
          </a>
        )}
        {future && !current && (
          <a href="/status" title="Planned Maintenance. See Status Page">
            <img src={statusFutureIssue} alt="Planned Maintenance" />
          </a>
        )}
      </div>
    )
  }

}
export default StatusMenu;

